import { api } from '../../shared/api/client';
import { useAsync } from '../../shared/ui/useAsync';

/** Logo y página pública de la iglesia: la portada de los perfiles. */
export function useChurchCover(churchId: string | null) {
  return useAsync(
    (signal) =>
      churchId
        ? api.get<{ slug: string; logoUrl: string | null }>(`/multichurch/public/join/${churchId}`, signal).catch(() => null)
        : Promise.resolve(null),
    [churchId],
  );
}
